/** View library */
import React from "react";
import Autobind from "autobind-decorator";
import ReactGA from "react-ga";
import { inject, observer } from "mobx-react";
import {
  Link,
  Route,
  Switch,
  Redirect,
  BrowserRouter as Router,
} from "react-router-dom";
import LoginForm from "component/molecules/loginForm";
import Constants from "constants/index";

@inject("authStore")
@observer
@Autobind
class LoginPage extends React.Component {
  componentDidMount() {
    // Notify GA that here is a login page
    // ReactGA.pageview("/login");
  }
  render() {
    const { authStore } = this.props;
    const isSignedIn = authStore.getIsSignedIn();

    return (
      <React.Fragment>
        {isSignedIn === true ? (
          <Redirect to={{ pathname: `${Constants.RootPrefix}/` }} />
        ) : (
          <LoginForm />
        )}
      </React.Fragment>
    );
  }
}

export default LoginPage;
